/* src/app/modules/institutions/institutions-sales/institutions-sales.component.scss */
:host .cw-submodule {
  width: 350px;
}
/*# sourceMappingURL=institutions-sales.component.css.map */
